import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_4afada721a4a39e35a1a66028f2134fd/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useSelector } from 'react-redux';
import ErrorState from 'components/ErrorState';
import * as selectors from 'state/auth/selectors';
import { AuthExternalRegisterView, AuthView } from 'state/auth/constants';
import { isValueInObject } from 'libs/utils/object';
import PasswordVerification from 'pages/PasswordVerificationLogin';
import SelectType from '../SelectType';
import EmailLogin from '../EmailLogin';
import EmailRegister from '../EmailRegister';
import ResetPassword from '../ResetPassword';
import FacebookRegister from '../FacebookRegister';
import GoogleRegister from '../GoogleRegister';
import AppleRegister from '../AppleRegister';
import { jsx as _jsx } from "react/jsx-runtime";
const componentByAuthView = {
  [AuthView.SelectTypeRegister]: SelectType,
  [AuthView.SelectTypeLogin]: SelectType,
  [AuthView.EmailLogin]: EmailLogin,
  [AuthView.EmailRegister]: EmailRegister,
  [AuthView.ResetPassword]: ResetPassword
};
const componentByAuthExternalRegisterView = {
  [AuthExternalRegisterView.FacebookRegister]: FacebookRegister,
  [AuthExternalRegisterView.GoogleRegister]: GoogleRegister,
  [AuthExternalRegisterView.AppleRegister]: AppleRegister,
  [AuthExternalRegisterView.PasswordVerification]: PasswordVerification
};

const Auth = () => {
  const view = useSelector(selectors.getAuthView);
  const externalRegisterData = useSelector(selectors.getExternalRegisterData);

  if (isValueInObject(view, AuthView)) {
    const Component = componentByAuthView[view];
    return /*#__PURE__*/_jsx(Component, {});
  }

  if (!externalRegisterData) return /*#__PURE__*/_jsx(ErrorState, {});
  const Component = componentByAuthExternalRegisterView[view];
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, externalRegisterData));
};

export default Auth;